import { __decorate, __metadata } from 'tslib';
import { NotEnumerable } from '../decorators/base.js';
import { EntityDescription } from './entity-description.js';
import { Store } from './store.js';

/**
 * 可存储数据的类
 * @public
 */
class Storable extends EntityDescription {
    constructor(target, propertyKey, index) {
        super(target, propertyKey, index);
        this.store = new Store([target, propertyKey, index]);
    }
}
__decorate([
    NotEnumerable(),
    __metadata("design:type", Store)
], Storable.prototype, "store", void 0);

export { Storable };
//# sourceMappingURL=storable.js.map
